import {AziendaEditorProps} from "../Azienda.generalita.page";
import React, {useEffect, useMemo} from "react";
import {Controller, useForm} from "react-hook-form";
import {AziendaRecord} from "@commons/mapping/AziendaRecord";
import CheckboxEx from "../../../components/wrapperComponents/CheckboxEx";
import {MotivoChiusuraAzienda} from "@commons/mapping/MotivoChiusuraAzienda";
import ComboBoxGenerica from "../../../components/comboBox/ComboBoxGenerica";
import DatePickerWrapper from "../../../components/DataPickerWrapper";
import FormButtons from "../../../components/FormButtons";
import {IconBook, IconClock, IconFileCheck, IconPresentation, IconRocket, IconUsersGroup} from "@tabler/icons-react";

const AmbitiAziendaEditor: React.FC<AziendaEditorProps> = ({defaultValues, resource, onSubmit, onCancel,}) => {
    const {watch, register, getValues, setValue, handleSubmit, reset, control, formState: {errors}} = useForm<AziendaRecord>();

    const initialValues: AziendaRecord = useMemo(() => {
        return {
            ...defaultValues, ...resource,
        };
    }, [resource, defaultValues]);

    useEffect(() => {
        reset(initialValues);
    }, [resource]);

    function onHandleSubmit(newValues: AziendaRecord) {
        onSubmit({
            ...newValues,
        })
    }

    const elencoMotiviChiusura: MotivoChiusuraAzienda[] = require('../../../data/motivo-chiusura.json');
    /*if (elencoMotiviChiusura) {
        console.log(elencoMotiviChiusura.length);
    }*/

    const watchFine = watch('validitaFine');
    const watchInizio = watch('validitaInizio');
    let valInizio = watchInizio !== null && watchInizio !== undefined && watchInizio !== '';
    let valFine = watchFine !== null && watchFine !== undefined && watchFine !== '';

    return <>
        <form className="p-1" onSubmit={handleSubmit(onHandleSubmit)}>

            <fieldset className="flexRowWrapFull border border-gray-200 pb-3 px-3">
                <legend className="px-2">Ambiti applicativi</legend>

                <div className="flexRowWrapFull">
                    <div className="sm1-3P">
                        <CheckboxEx control={control} name="ambitoPresenze"
                                    label={<span className="inline-flex">Presenze&nbsp;<IconClock className="h-5 w-5 self-center"/></span>}/>
                    </div>
                    <div className="sm1-3P">
                        <CheckboxEx control={control} name="ambitoCollocamento"
                                    label={<span className="inline-flex">Collocamento&nbsp;<IconRocket className="h-5 w-5 self-center"/></span>}/>
                    </div>
                    <div className="sm1-3P">
                        <CheckboxEx control={control} name="ambitoHR"
                                    label={<span className="inline-flex">HR&nbsp;<IconUsersGroup className="h-5 w-5 self-center"/></span>}/>
                    </div>
                </div>
                <div className="flexRowWrapFull sm:mt-3">
                    <div className="sm1-3P">
                        <CheckboxEx control={control} name="ambitoPVA"
                                    label={<span className="inline-flex">PVA - Analisi teste e costi&nbsp;<IconPresentation className="h-5 w-5 self-center"/></span>}/>
                    </div>
                    <div className="sm1-3P">
                        <CheckboxEx control={control} name="ambitoGAP"
                                    label={<span className="inline-flex">GAP&nbsp;<IconFileCheck className="h-5 w-5 self-center"/></span>}/>
                    </div>
                    <div className="sm1-3P">
                        <CheckboxEx control={control} name="ambitoDOCS"
                                    label={<span className="inline-flex">Documenti&nbsp;<IconBook className="h-5 w-5 self-center"/></span>}/>
                    </div>
                </div>
            </fieldset>

            <fieldset className="flexRowWrapFull border border-gray-200 pb-3 px-3">
                <legend className="px-2">Validit&agrave;</legend>

                <div className="flexRowWrapFull">
                    <div className="sm1-3P">
                        <label className="block text-sm font-semibold mb-1" htmlFor="validitaInizio">Data inizio</label>
                        <Controller name="validitaInizio" control={control} defaultValue={defaultValues.validitaInizio}
                                    render={({field: {value, onChange}, fieldState, formState}) =>
                                        (<DatePickerWrapper fieldState={fieldState} value={value} onChange={onChange} enabled/>)
                                    }
                        />
                    </div>
                    <div className="sm1-3P">
                        <label className={`block text-sm font-semibold mb-1 ${valInizio ? '' : 'text-gray-400'}`} htmlFor="validitaFine">Data fine</label>
                        <Controller name="validitaFine" control={control} defaultValue={defaultValues.validitaFine}
                                    render={({field: {value, onChange}, fieldState, formState}) =>
                                        (<DatePickerWrapper fieldState={fieldState} value={value} onChange={onChange} enabled={valInizio}/>)
                                    }
                        />
                    </div>
                    <div className="sm1-3P">
                        <ComboBoxGenerica label="Motivazione fine attività" control={control} name="motivoChiusura" defaultValue={initialValues.motivoChiusura}
                                          data={elencoMotiviChiusura} disabled={!valFine} rules={{required: valFine}}/>
                    </div>
                </div>
                <div className="flexRowWrapFull sm:mt-3">
                    <div className="sm1-3P">
                        <CheckboxEx control={control} name="validaSoloXBUDGET" label="UL valida solo per budget\forecast"/>
                    </div>
                    <div className="sm1-3P">
                        <CheckboxEx control={control} name="consideraComeUL" label="Considera master come UL"/>
                    </div>
                </div>
            </fieldset>

            <FormButtons onCancel={onCancel} resource={resource}/>

        </form>
    </>
}

export default AmbitiAziendaEditor;